import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { WarehouseItem } from "./useWarehouse";

// Hook para obtener items con stock bajo
// Solo incluye items donde min_stock_alert NO es null (tienen alerta configurada)
export const useLowStockAlerts = () => {
  return useQuery({
    queryKey: ["low-stock-alerts"],
    queryFn: async () => {
      // Obtener items donde min_stock_alert no es null
      const { data, error } = await supabase
        .from("warehouse_items")
        .select(`
          *,
          product:products(*),
          organization:organizations(id, name)
        `)
        .not("min_stock_alert", "is", null)
        .order("quantity", { ascending: true });

      if (error) throw error;

      // Filtrar en el cliente los que tienen stock bajo
      // (Supabase no permite comparar columnas directamente en el filtro)
      const lowStockItems = (data as WarehouseItem[]).filter(
        (item) => item.min_stock_alert !== null && item.quantity <= item.min_stock_alert
      );

      return lowStockItems;
    },
  });
};

// Hook para contar items con stock bajo
export const useLowStockCount = () => {
  const { data: lowStockItems = [] } = useLowStockAlerts();
  return lowStockItems.length;
};
